import { render, staticRenderFns } from "./EduProgram.vue?vue&type=template&id=dffaeb1a&"
import script from "./EduProgram.vue?vue&type=script&lang=js&"
export * from "./EduProgram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports